import { Component, Input, OnInit } from '@angular/core';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';

@Component({
  selector: 'app-moduleslistitem',
  templateUrl: './moduleslistitem.component.html',
  styleUrls: ['./moduleslistitem.component.css'],
})
export class ModuleslistitemComponent implements OnInit {
  @Input() module: any;
  @Input() fromDash: boolean;
  lessoncount: number;
  logcount: number;
  skippedclasses: any;
  nextclass: any;
  url: any;
  queryParam: any;

  // The user's token used to be read here for a live-meeting link that embedded it as a
  // query parameter. That link is gone; the token read went with it.
  constructor(private modulemanager: ModulemanagementService) {
  }

  progress: number;
  async ngOnInit() {
    this.lessoncount = this.module.lessonCount;
    this.logcount = this.module.lessonlogcount;
    this.progress = this.module.order;

    this.skippedclasses = await this.modulemanager
      .getSkippedClasses(this.module.id)
      .toPromise();
    this.nextclass = this.skippedclasses[0];
    this.url = this.nextclass ? '/user/lesson' : '/user/moduledetails';
    this.queryParam = this.nextclass
      ? { classid: this.nextclass.id, moduleid: this.module.id }
      : { moduleID: this.module.id, dash: this.fromDash };
  }
}
